import React from 'react';

import PDFIcon from '../assets/images/icon-file-pdf.svg';
import trackEvent from '../helpers/tracking';

const countryData = [
  ['Afghanistan_DHL_GCR_2026.pdf', 'Afghanistan', 'AFG'],
  ['Albania_DHL_GCR_2026.pdf', 'Albania', 'ALB'],
  ['Algeria_DHL_GCR_2026.pdf', 'Algeria', 'DZA'],
  ['Andorra_DHL_GCR_2026.pdf', 'Andorra', 'AND'],
  ['Angola_DHL_GCR_2026.pdf', 'Angola', 'AGO'],
  ['Antigua-and-Barbuda_DHL_GCR_2026.pdf', 'Antigua and Barbuda', 'ATG'],
  ['Argentina_DHL_GCR_2026.pdf', 'Argentina', 'ARG'],
  ['Armenia_DHL_GCR_2026.pdf', 'Armenia', 'ARM'],
  ['Australia_DHL_GCR_2026.pdf', 'Australia', 'AUS'],
  ['Austria_DHL_GCR_2026.pdf', 'Austria', 'AUT'],
  ['Azerbaijan_DHL_GCR_2026.pdf', 'Azerbaijan', 'AZE'],
  ['Bahamas_DHL_GCR_2026.pdf', 'Bahamas', 'BHS'],
  ['Bahrain_DHL_GCR_2026.pdf', 'Bahrain', 'BHR'],
  ['Bangladesh_DHL_GCR_2026.pdf', 'Bangladesh', 'BGD'],
  ['Barbados_DHL_GCR_2026.pdf', 'Barbados', 'BRB'],
  ['Belarus_DHL_GCR_2026.pdf', 'Belarus', 'BLR'],
  ['Belgium_DHL_GCR_2026.pdf', 'Belgium', 'BEL'],
  ['Belize_DHL_GCR_2026.pdf', 'Belize', 'BLZ'],
  ['Benin_DHL_GCR_2026.pdf', 'Benin', 'BEN'],
  ['Bhutan_DHL_GCR_2026.pdf', 'Bhutan', 'BTN'],
  ['Bolivia_DHL_GCR_2026.pdf', 'Bolivia (Plurinational State of)', 'BOL'],
  ['Bosnia-and-Herzegovina_DHL_GCR_2026.pdf', 'Bosnia and Herzegovina', 'BIH'],
  ['Botswana_DHL_GCR_2026.pdf', 'Botswana', 'BWA'],
  ['Brazil_DHL_GCR_2026.pdf', 'Brazil', 'BRA'],
  ['Brunei-Darussalam_DHL_GCR_2026.pdf', 'Brunei Darussalam', 'BRN'],
  ['Bulgaria_DHL_GCR_2026.pdf', 'Bulgaria', 'BGR'],
  ['Burkina-Faso_DHL_GCR_2026.pdf', 'Burkina Faso', 'BFA'],
  ['Burundi_DHL_GCR_2026.pdf', 'Burundi', 'BDI'],
  ['Cabo-Verde_DHL_GCR_2026.pdf', 'Cabo Verde', 'CPV'],
  ['Cambodia_DHL_GCR_2026.pdf', 'Cambodia', 'KHM'],
  ['Cameroon_DHL_GCR_2026.pdf', 'Cameroon', 'CMR'],
  ['Canada_DHL_GCR_2026.pdf', 'Canada', 'CAN'],
  ['Central-African-Republic_DHL_GCR_2026.pdf', 'Central African Republic', 'CAF'],
  ['Chad_DHL_GCR_2026.pdf', 'Chad', 'TCD'],
  ['Chile_DHL_GCR_2026.pdf', 'Chile', 'CHL'],
  ['China_DHL_GCR_2026.pdf', 'China', 'CHN'],
  ['Colombia_DHL_GCR_2026.pdf', 'Colombia', 'COL'],
  ['Congo_DHL_GCR_2026.pdf', 'Congo', 'COG'],
  ['Costa-Rica_DHL_GCR_2026.pdf', 'Costa Rica', 'CRI'],
  ['Cote-d-ivoire_DHL_GCR_2026.pdf', 'Cote d&#8217;Ivoire', 'CIV'],
  ['Croatia_DHL_GCR_2026.pdf', 'Croatia', 'HRV'],
  ['Cuba_DHL_GCR_2026.pdf', 'Cuba', 'CUB'],
  ['Cyprus_DHL_GCR_2026.pdf', 'Cyprus', 'CYP'],
  ['Czechia_DHL_GCR_2026.pdf', 'Czechia', 'CZE'],
  ['DR-Congo_DHL_GCR_2026.pdf', 'Democratic Republic of the Congo', 'COD'],
  ['Denmark_DHL_GCR_2026.pdf', 'Denmark', 'DNK'],
  ['Djibouti_DHL_GCR_2026.pdf', 'Djibouti', 'DJI'],
  ['Dominica_DHL_GCR_2026.pdf', 'Dominica', 'DMA'],
  ['Dominican-Republic_DHL_GCR_2026.pdf', 'Dominican Republic', 'DOM'],
  ['Ecuador_DHL_GCR_2026.pdf', 'Ecuador', 'ECU'],
  ['Egypt_DHL_GCR_2026.pdf', 'Egypt', 'EGY'],
  ['El-Salvador_DHL_GCR_2026.pdf', 'El Salvador', 'SLV'],
  ['Estonia_DHL_GCR_2026.pdf', 'Estonia', 'EST'],
  ['Eswatini_DHL_GCR_2026.pdf', 'Eswatini', 'SWZ'],
  ['Ethiopia_DHL_GCR_2026.pdf', 'Ethiopia', 'ETH'],
  ['Fiji_DHL_GCR_2026.pdf', 'Fiji', 'FJI'],
  ['Finland_DHL_GCR_2026.pdf', 'Finland', 'FIN'],
  ['France_DHL_GCR_2026.pdf', 'France', 'FRA'],
  ['Gabon_DHL_GCR_2026.pdf', 'Gabon', 'GAB'],
  ['Gambia_DHL_GCR_2026.pdf', 'Gambia', 'GMB'],
  ['Georgia_DHL_GCR_2026.pdf', 'Georgia', 'GEO'],
  ['Germany_DHL_GCR_2026.pdf', 'Germany', 'DEU'],
  ['Ghana_DHL_GCR_2026.pdf', 'Ghana', 'GHA'],
  ['Greece_DHL_GCR_2026.pdf', 'Greece', 'GRC'],
  ['Grenada_DHL_GCR_2026.pdf', 'Grenada', 'GRD'],
  ['Guatemala_DHL_GCR_2026.pdf', 'Guatemala', 'GTM'],
  ['Guinea_DHL_GCR_2026.pdf', 'Guinea', 'GIN'],
  ['Guinea-Bissau_DHL_GCR_2026.pdf', 'Guinea-Bissau', 'GNB'],
  ['Guyana_DHL_GCR_2026.pdf', 'Guyana', 'GUY'],
  ['Haiti_DHL_GCR_2026.pdf', 'Haiti', 'HTI'],
  ['Honduras_DHL_GCR_2026.pdf', 'Honduras', 'HND'],
  ['Hong-Kong_DHL_GCR_2026.pdf', 'Hong Kong SAR (China)', 'HKG'],
  ['Hungary_DHL_GCR_2026.pdf', 'Hungary', 'HUN'],
  ['Iceland_DHL_GCR_2026.pdf', 'Iceland', 'ISL'],
  ['India_DHL_GCR_2026.pdf', 'India', 'IND'],
  ['Indonesia_DHL_GCR_2026.pdf', 'Indonesia', 'IDN'],
  ['Iran_DHL_GCR_2026.pdf', 'Iran (Islamic Republic of)', 'IRN'],
  ['Iraq_DHL_GCR_2026.pdf', 'Iraq', 'IRQ'],
  ['Ireland_DHL_GCR_2026.pdf', 'Ireland', 'IRL'],
  ['Israel_DHL_GCR_2026.pdf', 'Israel', 'ISR'],
  ['Italy_DHL_GCR_2026.pdf', 'Italy', 'ITA'],
  ['Jamaica_DHL_GCR_2026.pdf', 'Jamaica', 'JAM'],
  ['Japan_DHL_GCR_2026.pdf', 'Japan', 'JPN'],
  ['Jordan_DHL_GCR_2026.pdf', 'Jordan', 'JOR'],
  ['Kazakhstan_DHL_GCR_2026.pdf', 'Kazakhstan', 'KAZ'],
  ['Kenya_DHL_GCR_2026.pdf', 'Kenya', 'KEN'],
  ['Kiribati_DHL_GCR_2026.pdf', 'Kiribati', 'KIR'],
  ['Korea_DHL_GCR_2026.pdf', 'Korea (Republic of)', 'KOR'],
  ['Kuwait_DHL_GCR_2026.pdf', 'Kuwait', 'KWT'],
  ['Kyrgyzstan_DHL_GCR_2026.pdf', 'Kyrgyzstan', 'KGZ'],
  ['Lao_DHL_GCR_2026.pdf', 'Lao People\u2019s Democratic Republic', 'LAO'],
  ['Latvia_DHL_GCR_2026.pdf', 'Latvia', 'LVA'],
  ['Lebanon_DHL_GCR_2026.pdf', 'Lebanon', 'LBN'],
  ['Lesotho_DHL_GCR_2026.pdf', 'Lesotho', 'LSO'],
  ['Liberia_DHL_GCR_2026.pdf', 'Liberia', 'LBR'],
  ['Libya_DHL_GCR_2026.pdf', 'Libya', 'LBY'],
  ['Lithuania_DHL_GCR_2026.pdf', 'Lithuania', 'LTU'],
  ['Luxembourg_DHL_GCR_2026.pdf', 'Luxembourg', 'LUX'],
  ['Macau-SAR_DHL_GCR_2026.pdf', 'Macau SAR (China)', 'MAC'],
  ['Madagascar_DHL_GCR_2026.pdf', 'Madagascar', 'MDG'],
  ['Malawi_DHL_GCR_2026.pdf', 'Malawi', 'MWI'],
  ['Malaysia_DHL_GCR_2026.pdf', 'Malaysia', 'MYS'],
  ['Maldives_DHL_GCR_2026.pdf', 'Maldives', 'MDV'],
  ['Mali_DHL_GCR_2026.pdf', 'Mali', 'MLI'],
  ['Malta_DHL_GCR_2026.pdf', 'Malta', 'MLT'],
  ['Marshall-Islands_DHL_GCR_2026.pdf', 'Marshall Islands', 'MHL'],
  ['Mauritania_DHL_GCR_2026.pdf', 'Mauritania', 'MRT'],
  ['Mauritius_DHL_GCR_2026.pdf', 'Mauritius', 'MUS'],
  ['Mexico_DHL_GCR_2026.pdf', 'Mexico', 'MEX'],
  ['Moldova_DHL_GCR_2026.pdf', 'Moldova', 'MDA'],
  ['Mongolia_DHL_GCR_2026.pdf', 'Mongolia', 'MNG'],
  ['Montenegro_DHL_GCR_2026.pdf', 'Montenegro', 'MNE'],
  ['Morocco_DHL_GCR_2026.pdf', 'Morocco', 'MAR'],
  ['Mozambique_DHL_GCR_2026.pdf', 'Mozambique', 'MOZ'],
  ['Myanmar_DHL_GCR_2026.pdf', 'Myanmar', 'MMR'],
  ['Namibia_DHL_GCR_2026.pdf', 'Namibia', 'NAM'],
  ['Nepal_DHL_GCR_2026.pdf', 'Nepal', 'NPL'],
  ['Netherlands_DHL_GCR_2026.pdf', 'Netherlands', 'NLD'],
  ['New-Zealand_DHL_GCR_2026.pdf', 'New Zealand', 'NZL'],
  ['Nicaragua_DHL_GCR_2026.pdf', 'Nicaragua', 'NIC'],
  ['Niger_DHL_GCR_2026.pdf', 'Niger', 'NER'],
  ['Nigeria_DHL_GCR_2026.pdf', 'Nigeria', 'NGA'],
  ['North-Macedonia_DHL_GCR_2026.pdf', 'North Macedonia', 'MKD'],
  ['Norway_DHL_GCR_2026.pdf', 'Norway', 'NOR'],
  ['Oman_DHL_GCR_2026.pdf', 'Oman', 'OMN'],
  ['Pakistan_DHL_GCR_2026.pdf', 'Pakistan', 'PAK'],
  ['Panama_DHL_GCR_2026.pdf', 'Panama', 'PAN'],
  ['Papua-New-Guinea_DHL_GCR_2026.pdf', 'Papua New Guinea', 'PNG'],
  ['Paraguay_DHL_GCR_2026.pdf', 'Paraguay', 'PRY'],
  ['Peru_DHL_GCR_2026.pdf', 'Peru', 'PER'],
  ['Philippines_DHL_GCR_2026.pdf', 'Philippines', 'PHL'],
  ['Poland_DHL_GCR_2026.pdf', 'Poland', 'POL'],
  ['Portugal_DHL_GCR_2026.pdf', 'Portugal', 'PRT'],
  ['Qatar_DHL_GCR_2026.pdf', 'Qatar', 'QAT'],
  ['Romania_DHL_GCR_2026.pdf', 'Romania', 'ROU'],
  ['Russian-Federation_DHL_GCR_2026.pdf', 'Russian Federation', 'RUS'],
  ['Rwanda_DHL_GCR_2026.pdf', 'Rwanda', 'RWA'],
  ['Samoa_DHL_GCR_2026.pdf', 'Samoa', 'WSM'],
  ['Sao-Tome-and-Principe_DHL_GCR_2026.pdf', 'Sao Tome and Principe', 'STP'],
  ['Saudi-Arabia_DHL_GCR_2026.pdf', 'Saudi Arabia', 'SAU'],
  ['Senegal_DHL_GCR_2026.pdf', 'Senegal', 'SEN'],
  ['Serbia_DHL_GCR_2026.pdf', 'Serbia', 'SRB'],
  ['Seychelles_DHL_GCR_2026.pdf', 'Seychelles', 'SYC'],
  ['Sierra-Leone_DHL_GCR_2026.pdf', 'Sierra Leone', 'SLE'],
  ['Singapore_DHL_GCR_2026.pdf', 'Singapore', 'SGP'],
  ['Slovakia_DHL_GCR_2026.pdf', 'Slovakia', 'SVK'],
  ['Slovenia_DHL_GCR_2026.pdf', 'Slovenia', 'SVN'],
  ['Solomon-Islands_DHL_GCR_2026.pdf', 'Solomon Islands', 'SLB'],
  ['South-Africa_DHL_GCR_2026.pdf', 'South Africa', 'ZAF'],
  ['Spain_DHL_GCR_2026.pdf', 'Spain', 'ESP'],
  ['Sri-Lanka_DHL_GCR_2026.pdf', 'Sri Lanka', 'LKA'],
  ['St-Kitts-and-Nevis_DHL_GCR_2026.pdf', 'St. Kitts and Nevis', 'KNA'],
  ['St-Lucia_DHL_GCR_2026.pdf', 'St. Lucia', 'LCA'],
  ['St-Vincent-and-the-Grenadines_DHL_GCR_2026.pdf', 'St. Vincent and the Grenadines', 'VCT'],
  ['Sudan_DHL_GCR_2026.pdf', 'Sudan', 'SDN'],
  ['Suriname_DHL_GCR_2026.pdf', 'Suriname', 'SUR'],
  ['Sweden_DHL_GCR_2026.pdf', 'Sweden', 'SWE'],
  ['Switzerland_DHL_GCR_2026.pdf', 'Switzerland', 'CHE'],
  ['Syria_DHL_GCR_2026.pdf', 'Syrian Arab Republic', 'SYR'],
  ['Taiwan_DHL_GCR_2026.pdf', 'Taiwan (China)', 'TWN'],
  ['Tajikistan_DHL_GCR_2026.pdf', 'Tajikistan', 'TJK'],
  ['Tanzania_DHL_GCR_2026.pdf', 'Tanzania (United Republic of)', 'TZA'],
  ['Thailand_DHL_GCR_2026.pdf', 'Thailand', 'THA'],
  ['Timor-Leste_DHL_GCR_2026.pdf', 'Timor-Leste', 'TLS'],
  ['Togo_DHL_GCR_2026.pdf', 'Togo', 'TGO'],
  ['Tonga_DHL_GCR_2026.pdf', 'Tonga', 'TON'],
  ['Trinidad-and-Tobago_DHL_GCR_2026.pdf', 'Trinidad and Tobago', 'TTO'],
  ['Tunisia_DHL_GCR_2026.pdf', 'Tunisia', 'TUN'],
  ['Turkey_DHL_GCR_2026.pdf', 'Turkey', 'TUR'],
  ['Uganda_DHL_GCR_2026.pdf', 'Uganda', 'UGA'],
  ['Ukraine_DHL_GCR_2026.pdf', 'Ukraine', 'UKR'],
  ['United-Arab-Emirates_DHL_GCR_2026.pdf', 'United Arab Emirates', 'ARE'],
  ['United-Kingdom_DHL_GCR_2026.pdf', 'United Kingdom', 'GBR'],
  ['United-States_DHL_GCR_2026.pdf', 'United States', 'USA'],
  ['Uruguay_DHL_GCR_2026.pdf', 'Uruguay', 'URY'],
  ['Uzbekistan_DHL_GCR_2026.pdf', 'Uzbekistan', 'UZB'],
  ['Vanuatu_DHL_GCR_2026.pdf', 'Vanuatu', 'VUT'],
  ['Venezuela_DHL_GCR_2026.pdf', 'Venezuela (Bolivarian Republic of)', 'VEN'],
  ['Vietnam_DHL_GCR_2026.pdf', 'Viet Nam', 'VNM'],
  ['Yemen_DHL_GCR_2026.pdf', 'Yemen', 'YEM'],
  ['Zambia_DHL_GCR_2026.pdf', 'Zambia', 'ZMB'],
  ['Zimbabwe_DHL_GCR_2026.pdf', 'Zimbabwe', 'ZWE'],
];

// eslint-disable-next-line react/prop-types
export default function PDFLink({ iso }) {
  const country = countryData.find((c) => c[2] === iso);

  if (!country) return false;

  const [fileName, title] = country;

  return (
    <a
      href={`https://www.dhl.com/content/dam/dhl/global/microsites/dhl-nyu/gcr-data/profiles/2026/${fileName}`}
      alt={`PDF Download Link ${title}`}
      target="_blank"
      rel="noopener noreferrer"
      download
      onClick={() => trackEvent({
        event: 'download_country_profile',
        value: title,
      })}
    >
      <img src={PDFIcon} alt={`PDF Download ${title}`} />
    </a>
  );
}
